"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _differenceBy = _interopRequireDefault(require("lodash/differenceBy"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _RecipientItem = _interopRequireDefault(require("./RecipientItem"));

var _RecipientInput = _interopRequireDefault(require("./RecipientInput"));

var _Strip = _interopRequireDefault(require("./Strip"));

var _utils = require("../../utils");

function removeIndex(array, index) {
  var newArray = (0, _toConsumableArray2["default"])(array);
  newArray.splice(index, 1);
  return newArray;
}

var MoreComponent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var index = _ref.index,
      number = _ref.number,
      recipients = _ref.recipients,
      stripWidth = _ref.stripWidth;
  var isAllEmail = (0, _react.useMemo)(function () {
    return recipients.slice(index).every(function (item) {
      return (0, _utils.isEmail)(item.email);
    });
  }, [recipients, index]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: ref,
    className: (0, _classnames["default"])('text-sm font-semibold inline-flex', {
      'text-primary': isAllEmail,
      'text-red': !isAllEmail
    }),
    style: {
      width: stripWidth
    }
  }, "+ ", number, " others");
});

function RecipientContainer(_ref2, ref) {
  var recipients = _ref2.recipients,
      getRecipientAvatar = _ref2.getRecipientAvatar,
      contacts = _ref2.contacts,
      onChangeRecipients = _ref2.onChangeRecipients,
      _onSelectRecipient = _ref2.onSelectRecipient,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["recipients", "getRecipientAvatar", "contacts", "onChangeRecipients", "onSelectRecipient"]);
  var containerRef = (0, _react.useRef)();
  var inputRef = (0, _react.useRef)();
  var noRepeatContacts = (0, _react.useMemo)(function () {
    return (0, _differenceBy["default"])(contacts, recipients, 'email');
  }, [contacts, recipients]);

  var _useState = (0, _react.useState)(props.autoFocus || false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      expand = _useState2[0],
      setExpand = _useState2[1];

  var isFocusedRef = (0, _react.useRef)(false);
  var itemNodes = recipients.map(function (item, index) {
    var sameRecipients = recipients.filter(function (each) {
      return item.email === each.email;
    });
    var currIndex = sameRecipients.indexOf(item);
    return /*#__PURE__*/_react["default"].createElement(_RecipientItem["default"], {
      getRecipientAvatar: getRecipientAvatar,
      containerRef: containerRef,
      onSelectRecipient: function onSelectRecipient() {
        return _onSelectRecipient(item);
      },
      contacts: item.name ? noRepeatContacts.concat(item) : noRepeatContacts,
      recipient: item,
      key: "".concat(item.email, "_").concat(currIndex),
      onChangeRecipient: function onChangeRecipient() {
        for (var _len = arguments.length, updateRecipients = new Array(_len), _key = 0; _key < _len; _key++) {
          updateRecipients[_key] = arguments[_key];
        }

        if (!updateRecipients.length) return;

        if (!updateRecipients[0]) {
          onChangeRecipients(removeIndex(recipients, index));
        } else {
          var newRecipients = (0, _toConsumableArray2["default"])(recipients);
          newRecipients.splice.apply(newRecipients, [index, 1].concat(updateRecipients));
          onChangeRecipients(newRecipients);
        } //use timeout avoid repeat trigger change reicpient event.


        setTimeout(function () {
          return inputRef.current && inputRef.current.focus();
        });
      },
      onBackspace: function onBackspace() {
        if (index !== 0) {
          onChangeRecipients(removeIndex(recipients, index - 1));
        }
      }
    });
  });

  function handleFocus(e) {
    isFocusedRef.current = true;
    setTimeout(function () {
      document.visibilityState === 'visible' && setExpand(isFocusedRef.current);
    });
  }

  function handleBlur(e) {
    isFocusedRef.current = false;
    setTimeout(function () {
      document.visibilityState === 'visible' && setExpand(isFocusedRef.current);
    });
  }

  (0, _react.useEffect)(function () {
    expand && inputRef.current && inputRef.current.focus();
  }, [expand]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        var _inputRef$current;

        return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      },
      blur: function blur() {
        var _inputRef$current2;

        return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef,
    className: "inline-flex flex-wrap items-center w-full -m-1 outline-none",
    tabIndex: expand ? -1 : 0,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, expand || !recipients.length ? itemNodes : /*#__PURE__*/_react["default"].createElement(_Strip["default"], {
    moreComponent: MoreComponent,
    moreComponentProps: {
      recipients: recipients
    }
  }, itemNodes), (expand || !recipients.length) && /*#__PURE__*/_react["default"].createElement(_RecipientInput["default"], (0, _extends2["default"])({}, props, {
    getRecipientAvatar: getRecipientAvatar,
    ref: inputRef,
    className: "flex-grow",
    containerRef: containerRef,
    contacts: noRepeatContacts,
    onChangeRecipient: function onChangeRecipient() {
      for (var _len2 = arguments.length, updateRecipients = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        updateRecipients[_key2] = arguments[_key2];
      }

      if (updateRecipients.length && updateRecipients[0]) {
        onChangeRecipients(recipients.concat(updateRecipients));

        if (inputRef.current) {
          //first resize to avoid input width make the previous recipient item overflow
          inputRef.current.resize();
          inputRef.current.clearValue();
        }
      }
    },
    onBackspace: function onBackspace() {
      onChangeRecipients(removeIndex(recipients, recipients.length - 1));
    }
  })));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(RecipientContainer);

exports["default"] = _default;
//# sourceMappingURL=RecipientContainer.js.map